module.exports = __webpack_public_path__ + "img/img9.1a482f80.png";